const WenchamBlock = () => {
    return (
   <div className="communtiy-box country-groups" >
                <h2 className="box-title">WenCHAM</h2>
            <a className="" href="https://id.wbaforum.org/wenchamApplication" target="_blank">
                   <img src="https://id.wbaforum.org/contents/images/cards/withname/wencham.png" width={"100%"}/>
            </a>
                {/* <p className="viewall-link"><a href="#">+ JOIN THE GROUP</a></p> */}
            </div>
    );
};

export default WenchamBlock;
